import { Phone } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const PhoneIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Phone width={size} height={size} color={color} {...rest} />;

PhoneIcon.displayName = 'PhoneIcon';

export default PhoneIcon;
